import Service from './Service';
import StringUtil from '../util/StringUtil';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class AnotacaoService extends Service {
    salvarAnotacao(idSessao, numeroProcesso, anotacao, clienteEnvelopeId) {
        let promise;
        if (anotacao && anotacao.length > 0) {
            promise = this.getAnotacaoApi().salvarAnotacao(idSessao, numeroProcesso, anotacao);
        } else {
            promise = this.getAnotacaoApi().excluirAnotacao(idSessao, numeroProcesso);
        }
        return promise;
    }

    salvarComplementoAnotacao(idSessao, numeroProcesso, anotacao, clienteEnvelopeId) {
        let promise;
        if (anotacao && anotacao.length > 0) {
            console.log(anotacao);
            anotacao = StringUtil.tratarCaracteresNaoLatin1(anotacao);
            promise = this.getAnotacaoApi().salvarComplementoAnotacao(idSessao, numeroProcesso, anotacao);
        } else {
            promise = this.getAnotacaoApi().excluirComplementoAnotacao(idSessao, numeroProcesso);
        }
        promise.then(() => {
            if (anotacao && anotacao.length > 1024) {
                //se anotacao form muito grande, somente informa alteração do processo
                //limite default da especificação HTTP é 2048
                this.getSessaoApi().notificarAlterarProcesso(idSessao, numeroProcesso, clienteEnvelopeId);
            } else {
                this.getSessaoApi().notificarAlterarProcesso(
                    idSessao,
                    numeroProcesso,
                    clienteEnvelopeId,
                    'informacaoProcessoSalaSessao.complementoAnotacoes',
                    anotacao
                );
            }
        });
        return promise;
    }
}

export default AnotacaoService;
